const gameTypes = [
    { label: 'Favorite Player', value: 'favorite_player' },
    { label: 'First Scorer', value: 'first_scorer' },
    { label: 'Live Mood', value: 'live_mood' },
];

export default gameTypes;
